import {writable} from "svelte/store";


let template = {opened: 0, clicks: 0, bounces: 0, age: 0, results: []}
if(typeof window !== 'undefined' && sessionStorage.getItem('mailStatus')) {
    template = JSON.parse(sessionStorage.mailStatus)
}
export const mailStatus = writable(template)

mailStatus.subscribe(val => {
    if(typeof window !== 'undefined') {
        sessionStorage.setItem('mailStatus', JSON.stringify(val))
    }
})